var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirefox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_3956)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.27 8.0344C22.7587 6.8209 21.7218 5.51068 20.9097 5.09653C21.4888 6.20315 21.8908 7.39157 22.1012 8.61954L22.1034 8.63902C20.7731 5.36723 18.5173 4.04804 16.6749 1.17547C16.5797 1.02904 16.4873 0.880878 16.3978 0.731061C16.3516 0.652798 16.3084 0.572895 16.2681 0.491514C16.1917 0.34554 16.1328 0.191257 16.0926 0.0318004C16.0927 0.024434 16.09 0.0172998 16.0851 0.0117672C16.0801 0.00623453 16.0733 0.00269324 16.0659 0.00182299C16.0586 4.33773e-05 16.051 4.33773e-05 16.0438 0.00182299C16.0423 0.00182299 16.0398 0.00453997 16.038 0.00517394C16.0361 0.0058079 16.0322 0.00843431 16.0295 0.00961167L16.034 0.00182299C13.0788 1.7089 12.076 4.86893 11.9838 6.44958C10.8036 6.52956 9.67522 6.95857 8.74589 7.68065C8.64895 7.5996 8.5476 7.52383 8.44229 7.45369C8.17415 6.52801 8.16274 5.54831 8.40924 4.6168C7.32393 5.13542 6.35958 5.87066 5.57723 6.77598H5.57172C5.10545 6.19292 5.13822 4.27029 5.16493 3.86863C5.02701 3.92339 4.89534 3.99236 4.7721 4.0744C4.36048 4.36423 3.97567 4.68943 3.62215 5.04617C3.21937 5.44911 2.85148 5.88459 2.52232 6.34806V6.34978V6.34769C1.76602 7.40569 1.22951 8.60092 0.943734 9.86447L0.928036 9.94108C0.884618 10.1819 0.846052 10.4236 0.812361 10.6659C0.812361 10.6746 0.810525 10.6826 0.809607 10.6913C0.706572 11.2194 0.642751 11.7541 0.618652 12.2914V12.3513C0.626548 21.2867 10.4367 26.8627 18.2768 22.3883C19.7689 21.5367 21.0531 20.3721 22.0386 18.9769C23.024 17.5816 23.6867 15.9898 23.9798 14.3141C23.9995 14.1644 24.0156 14.0161 24.0332 13.8649C24.2755 11.889 24.0132 9.88473 23.27 8.0344ZM9.70938 17.1198C9.76437 17.1459 9.81597 17.1741 9.87243 17.1989L9.8806 17.204C9.8231 17.1768 9.76602 17.1487 9.70938 17.1198ZM22.1043 8.64173V8.63059L22.1064 8.64291L22.1043 8.64173Z",
    fill: "#178BEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.27 8.03431C22.7587 6.82081 21.7218 5.51059 20.9097 5.09644C21.4888 6.20306 21.8908 7.39148 22.1012 8.61945V8.6305L22.1034 8.64282C23.0102 11.2029 22.879 14.0096 21.7372 16.4765C20.3888 19.3308 17.1248 22.2563 12.0156 22.1141C6.49519 21.9598 1.63347 17.9188 0.724595 12.6258C0.559163 11.7912 0.724595 11.368 0.807771 10.6897C0.694263 11.2166 0.630948 11.7528 0.618652 12.2913V12.3512C0.626548 21.2866 10.4367 26.8626 18.2768 22.3882C19.7689 21.5366 21.0531 20.372 22.0386 18.9768C23.024 17.5816 23.6867 15.9898 23.9798 14.314C23.9995 14.1643 24.0156 14.016 24.0332 13.8648C24.2755 11.8889 24.0132 9.88464 23.27 8.03431Z",
    fill: "url(#paint0_radial_69_3956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.27 8.03431C22.7587 6.82081 21.7218 5.51059 20.9097 5.09644C21.4888 6.20306 21.8908 7.39148 22.1012 8.61945V8.6305L22.1034 8.64282C23.0102 11.2029 22.879 14.0096 21.7372 16.4765C20.3888 19.3308 17.1248 22.2563 12.0156 22.1141C6.49519 21.9598 1.63347 17.9188 0.724595 12.6258C0.559163 11.7912 0.724595 11.368 0.807771 10.6897C0.694263 11.2166 0.630948 11.7528 0.618652 12.2913V12.3512C0.626548 21.2866 10.4367 26.8626 18.2768 22.3882C19.7689 21.5366 21.0531 20.372 22.0386 18.9768C23.024 17.5816 23.6867 15.9898 23.9798 14.314C23.9995 14.1643 24.0156 14.016 24.0332 13.8648C24.2755 11.8889 24.0132 9.88464 23.27 8.03431Z",
    fill: "url(#paint1_radial_69_3956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5526 9.39866C17.5781 9.41632 17.6018 9.43398 17.6258 9.45164C17.3302 8.93467 16.9623 8.46135 16.5329 8.0456C12.8761 4.43754 15.5746 0.222418 16.0296 0.00832031L16.0341 0.00170898C13.0789 1.70879 12.0762 4.86882 11.9839 6.44947C12.1211 6.44014 12.2571 6.42873 12.3974 6.42873C13.446 6.43064 14.4753 6.70645 15.3808 7.22811C16.2863 7.74976 17.0357 8.49866 17.5526 9.39866Z",
    fill: "url(#paint2_radial_69_3956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4053 10.1194C12.3859 10.4082 11.3519 11.4038 10.9903 11.4038C7.64468 11.4038 7.10156 13.4005 7.10156 13.4005C7.24974 15.0817 8.43733 16.4665 9.87288 17.199C9.93843 17.2326 10.005 17.2628 10.0715 17.2924C10.1852 17.3422 10.3004 17.3887 10.4169 17.432C10.9096 17.604 11.4256 17.7022 11.9478 17.7234C17.8119 17.9947 18.9479 10.8056 14.7161 8.71937C15.7144 8.5912 16.7254 8.83336 17.5529 9.39889C17.036 8.49889 16.2867 7.74999 15.3812 7.22833C14.4757 6.70668 13.4463 6.43087 12.3977 6.42896C12.2581 6.42896 12.1215 6.44037 11.9842 6.44969C10.804 6.52967 9.67567 6.95868 8.74634 7.68076C8.92573 7.83056 9.12825 8.03062 9.55478 8.44532C10.3531 9.22129 12.4007 10.0251 12.4053 10.1194Z",
    fill: "url(#paint3_radial_69_3956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4053 10.1194C12.3859 10.4082 11.3519 11.4038 10.9903 11.4038C7.64468 11.4038 7.10156 13.4005 7.10156 13.4005C7.24974 15.0817 8.43733 16.4665 9.87288 17.199C9.93843 17.2326 10.005 17.2628 10.0715 17.2924C10.1852 17.3422 10.3004 17.3887 10.4169 17.432C10.9096 17.604 11.4256 17.7022 11.9478 17.7234C17.8119 17.9947 18.9479 10.8056 14.7161 8.71937C15.7144 8.5912 16.7254 8.83336 17.5529 9.39889C17.036 8.49889 16.2867 7.74999 15.3812 7.22833C14.4757 6.70668 13.4463 6.43087 12.3977 6.42896C12.2581 6.42896 12.1215 6.44037 11.9842 6.44969C10.804 6.52967 9.67567 6.95868 8.74634 7.68076C8.92573 7.83056 9.12825 8.03062 9.55478 8.44532C10.3531 9.22129 12.4007 10.0251 12.4053 10.1194Z",
    fill: "url(#paint4_radial_69_3956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.19752 7.29456C8.27949 7.34602 8.36045 7.39904 8.44034 7.45359C8.17221 6.52791 8.1608 5.54821 8.40729 4.6167C7.32195 5.13531 6.35757 5.87055 5.5752 6.77588C5.63257 6.77434 7.33932 6.7441 8.19752 7.29456Z",
    fill: "url(#paint5_radial_69_3956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.726538 12.6258C1.63449 17.9187 6.49713 21.9598 12.0176 22.114C17.1267 22.2566 20.3906 19.3308 21.7392 16.4765C22.8809 14.0096 23.0121 11.2028 22.1053 8.64278V8.63173C22.1053 8.62304 22.1035 8.61788 22.1053 8.62059L22.1074 8.64007C22.5248 11.3284 21.1387 13.933 18.9718 15.6942L18.9651 15.7092C14.7431 19.1013 10.7025 17.7558 9.88465 17.2065C9.82713 17.1794 9.77005 17.1513 9.71343 17.1224C7.25177 15.9616 6.23485 13.7491 6.45279 11.8516C5.86844 11.8602 5.29413 11.7013 4.79944 11.3944C4.30475 11.0874 3.91092 10.6455 3.66568 10.1222C4.31188 9.73168 5.04867 9.51092 5.80587 9.48094C6.56306 9.45096 7.31542 9.61276 7.99126 9.95092C9.38462 10.5749 10.9701 10.6364 12.4088 10.1222C12.4043 10.0278 10.3567 9.22376 9.55828 8.44816C9.13176 8.03336 8.92933 7.83357 8.74994 7.6836C8.65301 7.60252 8.55166 7.52672 8.44634 7.45655C8.37648 7.40954 8.29789 7.35865 8.20352 7.29751C7.34532 6.74705 5.63857 6.7773 5.58211 6.77884H5.5767C5.11042 6.19578 5.14319 4.27315 5.16991 3.87158C5.03199 3.92631 4.90031 3.99525 4.77707 4.07726C4.36546 4.36709 3.98064 4.69229 3.62712 5.04903C3.22289 5.45084 2.85346 5.88532 2.52271 6.34793V6.34965V6.34757C1.7664 7.40556 1.22989 8.60079 0.944116 9.86434C0.938424 9.88797 0.520344 11.6908 0.726538 12.6258Z",
    fill: "url(#paint6_radial_69_3956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5337 8.04572C16.9632 8.46193 17.3311 8.93579 17.6265 9.45329C17.6875 9.49812 17.7463 9.54569 17.8029 9.59585C20.4704 12.0216 19.0727 15.4506 18.9686 15.6947C21.1355 13.9334 22.5204 11.3289 22.1042 8.64046C20.7733 5.36723 18.5175 4.04804 16.6751 1.17547C16.58 1.02904 16.4876 0.880878 16.398 0.731061C16.3518 0.652798 16.3086 0.572895 16.2683 0.491514C16.1919 0.34554 16.133 0.191257 16.0928 0.0318004C16.0929 0.024434 16.0902 0.0172998 16.0853 0.0117672C16.0803 0.00623453 16.0735 0.00269324 16.0661 0.00182299C16.0588 4.33773e-05 16.0512 4.33773e-05 16.044 0.00182299C16.0425 0.00182299 16.04 0.00453997 16.0382 0.00517394C16.0363 0.0058079 16.0324 0.00843431 16.0297 0.00961167C15.5747 0.222532 12.8762 4.43766 16.5337 8.04572Z",
    fill: "url(#paint7_radial_69_3956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8012 9.59411C17.7446 9.54395 17.6858 9.49638 17.6248 9.45156C17.6008 9.4339 17.5772 9.41624 17.5516 9.39858C16.7241 8.83306 15.7131 8.59089 14.7148 8.71906C18.9465 10.8064 17.8112 17.9944 11.9465 17.723C11.4243 17.7019 10.9083 17.6037 10.4156 17.4317C10.2991 17.3886 10.1839 17.3421 10.0702 17.2921C10.0036 17.2622 9.93713 17.2323 9.87158 17.1987L9.87975 17.2038C10.6976 17.7546 14.7369 19.1001 18.9602 15.7064L18.9669 15.6915C19.0722 15.4488 20.4698 12.019 17.8012 9.59411Z",
    fill: "url(#paint8_radial_69_3956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.1011 13.4002C7.1011 13.4002 7.64422 11.4036 10.9899 11.4036C11.3514 11.4036 12.3863 10.4079 12.4049 10.1192C10.9662 10.6334 9.38064 10.5719 7.9873 9.94785C7.31143 9.60969 6.55905 9.4479 5.80184 9.47789C5.04463 9.50789 4.30782 9.72867 3.66162 10.1192C3.90686 10.6425 4.30069 11.0844 4.79538 11.3914C5.29007 11.6983 5.86438 11.8572 6.44873 11.8486C6.23079 13.7465 7.24771 15.959 9.70938 17.1194C9.76437 17.1455 9.81596 17.1737 9.87242 17.1985C8.43567 16.4662 7.24927 15.0815 7.1011 13.4002Z",
    fill: "url(#paint9_radial_69_3956)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.27 8.0344C22.7587 6.8209 21.7218 5.51068 20.9097 5.09653C21.4888 6.20315 21.8908 7.39157 22.1012 8.61954L22.1034 8.63902C20.7731 5.36723 18.5173 4.04804 16.6749 1.17547C16.5797 1.02904 16.4873 0.880878 16.3978 0.731061C16.3516 0.652798 16.3084 0.572895 16.2681 0.491514C16.1917 0.34554 16.1328 0.191257 16.0926 0.0318004C16.0927 0.024434 16.09 0.0172998 16.0851 0.0117672C16.0801 0.00623453 16.0733 0.00269324 16.0659 0.00182299C16.0586 4.33773e-05 16.051 4.33773e-05 16.0438 0.00182299C16.0423 0.00182299 16.0398 0.00453997 16.038 0.00517394C16.0361 0.0058079 16.0322 0.00843431 16.0295 0.00961167L16.034 0.00182299C13.0788 1.7089 12.076 4.86893 11.9838 6.44958C12.121 6.44025 12.257 6.42884 12.3973 6.42884C13.4458 6.43076 14.4752 6.70656 15.3807 7.22822C16.2862 7.74988 17.0355 8.49878 17.5525 9.39877C16.7249 8.83325 15.7139 8.59109 14.7156 8.71926C18.9475 10.8066 17.8121 17.9946 11.9473 17.7232C11.4251 17.7021 10.9091 17.6039 10.4165 17.4319C10.2999 17.3888 10.1847 17.3423 10.071 17.2923C10.0045 17.2624 9.93798 17.2325 9.87243 17.1989L9.8806 17.204C9.8231 17.1768 9.76602 17.1487 9.70938 17.1198C9.76437 17.1459 9.81597 17.1741 9.87243 17.1989C8.43568 16.4664 7.24928 15.0816 7.10111 13.4003C7.10111 13.4003 7.64422 11.4037 10.9899 11.4037C11.3514 11.4037 12.3863 10.408 12.4049 10.1193C12.4003 10.0249 10.3527 9.2209 9.55432 8.4452C9.1278 8.0305 8.92527 7.83071 8.74589 7.68065C8.64895 7.5996 8.5476 7.52383 8.44229 7.45369C8.17415 6.52801 8.16274 5.54831 8.40924 4.6168C7.32393 5.13542 6.35958 5.87066 5.57723 6.77598H5.57172C5.10545 6.19292 5.13822 4.27029 5.16493 3.86863C5.02701 3.92339 4.89534 3.99236 4.7721 4.0744C4.36048 4.36423 3.97567 4.68943 3.62215 5.04617C3.21937 5.44911 2.85148 5.88459 2.52232 6.34806V6.34978V6.34769C1.76602 7.40569 1.22951 8.60092 0.943734 9.86447L0.928036 9.94108C0.905819 10.0432 0.806577 10.5619 0.792256 10.6733C0.792256 10.6817 0.792256 10.6646 0.792256 10.6733C0.701449 11.2087 0.643476 11.7491 0.618652 12.2914V12.3513C0.626548 21.2867 10.4367 26.8627 18.2768 22.3883C19.7689 21.5367 21.0531 20.3721 22.0386 18.9769C23.024 17.5816 23.6867 15.9898 23.9798 14.3141C23.9995 14.1644 24.0156 14.0161 24.0332 13.8649C24.2755 11.889 24.0132 9.88473 23.27 8.0344Z",
    fill: "url(#paint10_linear_69_3956)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_69_3956",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.8105 2.65843) scale(24.5277 24.1967)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.129,
    stopColor: "#FFBD4F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#FFAC31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.247,
    stopColor: "#FF9D17"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.283,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.403,
    stopColor: "#FF563B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467,
    stopColor: "#FF3750"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71,
    stopColor: "#F5156C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.782,
    stopColor: "#EB0878"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#E50080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_69_3956",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.8479 12.5507) scale(24.5277 24.1967)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#960E18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.351,
    stopColor: "#B11927",
    stopOpacity: 0.74
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.435,
    stopColor: "#DB293D",
    stopOpacity: 0.343
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.497,
    stopColor: "#F5334B",
    stopOpacity: 0.094
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FF3750",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_69_3956",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.8051 -2.83276) scale(17.7693 17.5295)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.132,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.252,
    stopColor: "#FFDC3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.506,
    stopColor: "#FF9D12"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.526,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_69_3956",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.1353 18.8713) scale(11.6787 11.5211)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.353,
    stopColor: "#3A8EE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.472,
    stopColor: "#5C79F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.669,
    stopColor: "#9059FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C139E6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_69_3956",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.1924 10.5682) rotate(-13.4147) scale(6.18739 7.15672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.206,
    stopColor: "#9059FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.278,
    stopColor: "#8C4FF3",
    stopOpacity: 0.064
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.747,
    stopColor: "#7716A8",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.975,
    stopColor: "#6E008B",
    stopOpacity: 0.6
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_69_3956",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5384 1.66836) scale(8.40166 8.28826)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE226"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.121,
    stopColor: "#FFDB27"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.295,
    stopColor: "#FFC82A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.502,
    stopColor: "#FFA930"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.732,
    stopColor: "#FF7E37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.792,
    stopColor: "#FF7139"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_69_3956",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.1425 -3.58865) scale(35.8461 35.3623)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.113,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.456,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.622,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.716,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_69_3956",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1269 -1.62293) rotate(83.8943) scale(25.9218 17.2398)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FFE847"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.168,
    stopColor: "#FFC830"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.304,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.356,
    stopColor: "#FF8B16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.455,
    stopColor: "#FF672A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.737,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_69_3956",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.3406 4.73818) scale(22.3793 22.0773)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.137,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF980E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.592,
    stopColor: "#FF5634"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#FF3647"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.904,
    stopColor: "#E31587"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_69_3956",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(17.2478 6.03049) scale(24.494 24.1634)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.094,
    stopColor: "#FFF44F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.231,
    stopColor: "#FFE141"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.509,
    stopColor: "#FFAF1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.626,
    stopColor: "#FF980E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_69_3956",
    x1: 21.478,
    y1: 3.61107,
    x2: 5.08444,
    y2: 20.2286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.167,
    stopColor: "#FFF44F",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.266,
    stopColor: "#FFF44F",
    stopOpacity: 0.634
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.489,
    stopColor: "#FFF44F",
    stopOpacity: 0.217
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#FFF44F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_3956"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.0013,
    height: 24,
    fill: "white",
    transform: "translate(0.499512)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefox);
export default __webpack_public_path__ + "static/media/firefox.8905d21773c4ce91f3d85cec271f3fd1.svg";
export { ForwardRef as ReactComponent };